import styled from 'styled-components';

export const LoadContainer = styled.div<{index:number}>`
    margin-top:120px;
    height:100vh;
    box-sizing:border-box;
    padding-top:120px;
    width:100%;
    position:fixed;
    background-color: #F3F3FD;
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    z-index:${props=>props.index}
`;

export const LoadingText = styled.span`
margin-top:10px;
font-family: Nunito;
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 140%;
color: #454ADE;
`;